/**
 * 숫자 포맷팅 헬퍼 함수
 * @param {number|string} num - 포맷팅할 숫자
 * @returns {string} 천 단위 콤마가 포함된 문자열
 */
export const formatNumber = (num) => {
  if (num === null || num === undefined || num === '') return '';
  return Number(num).toLocaleString();
};

/**
 * 날짜 포맷팅 함수
 * @param {string} dateStr - YYYYMMDD 형식의 날짜 문자열
 * @returns {string} YYYY-MM-DD 형식의 날짜 문자열
 */
export const formatDate = (dateStr) => {
  if (!dateStr || dateStr.length !== 8) return dateStr;
  return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
};

/**
 * 기간 포맷팅 함수
 * @param {string} startDate - 시작일
 * @param {string} endDate - 종료일
 * @returns {string} YYYY-MM-DD ~ YYYY-MM-DD 포맷팅된 기간
 */
export const formatMedicalPeriod = (startDate, endDate) => {
  if (!startDate || !endDate) return '';
  return `${formatDate(startDate)} ~ ${formatDate(endDate)}`;
};

/**
 * 날짜 포맷팅 함수
 * @param {string} dateStr - YYYYMMDD 형식의 날짜 문자열
 * @returns {string} YYYY년 MM월 DD일 형식의 날짜 문자열
 */
export const formateDateToKorean = (dateStr) => {
  if (!dateStr || dateStr.length !== 8) return dateStr;
  return `${dateStr.substring(0, 4)}년 ${dateStr.substring(4, 6)}월 ${dateStr.substring(6, 8)}일`;
};

/**
 * 날짜 포맷팅 함수
 * @param {string} dateStr - YYYYMMDD 형식의 날짜 문자열
 * @returns {string} YYYY/MM/DD 형식의 날짜 문자열
 */
export const formatDateToSlash = (dateStr) => {
  if (!dateStr) return '';
  if (dateStr.length === 8) {
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);
    return `${year}/${month}/${day}`;
  }
  return dateStr;
};

/**
 * 진료일 포맷팅 함수
 * @param {string} dateString - YYYYMMDD 형식의 날짜 문자열
 * @returns {string} YYYY.MM.DD (요일) 형식의 날짜 문자열
 */
export const formatDateToKoreanWithWeekday = (dateString) => {
  if (!dateString || dateString.length !== 8) {
    return dateString;
  }

  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);

  const date = new Date(year, month - 1, day);

  // 요일 배열
  const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
  const weekday = weekdays[date.getDay()];

  return `${year}.${month}.${day} (${weekday})`;
};

/**
 * 날짜 포맷팅 함수
 * @param {string} dateTimeString - YYYYMMDDHHMMSS 형식의 날짜 문자열
 * @returns {string} YYYY.MM.DD (요일) 오전/오후 HH시 MM분 형식의 날짜 문자열
 */
export const formatDateTimeToKoreanWithWeekday = (dateTimeString) => {
  if (!dateTimeString || dateTimeString.length !== 14) return dateTimeString;

  const year = dateTimeString.substring(0, 4);
  const month = dateTimeString.substring(4, 6);
  const day = dateTimeString.substring(6, 8);
  const hour = parseInt(dateTimeString.substring(8, 10), 10);
  const minute = parseInt(dateTimeString.substring(10, 12), 10);
  // const second = dateTimeString.substring(12, 14); // 필요시 사용

  const date = new Date(year, month - 1, day);
  const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
  const weekday = weekdays[date.getDay()];

  // 오전/오후, 12시간제 변환
  const isAM = hour < 12;
  let hour12 = hour % 12;
  if (hour12 === 0) hour12 = 12;
  const ampm = isAM ? '오전' : '오후';

  return {
    date: `${year}.${month}.${day} (${weekday})`,
    time: `${ampm} ${hour12}시 ${minute}분`,
  };
};

export const formatTel = (tel) => {
  if (!tel) return '';
  return tel.replace(/(\d{2,3})(\d{3,4})(\d{4})/, '$1-$2-$3');
};
